import { useCallback, useEffect, useRef, useState } from "react";
import { prepopulateFilterFromDefaultValues, generateFilterQueryParams } from "@utils/filtering";
import useDetectCurrentCulture from "./useDetectCurrentCulture";
import { useApi } from "./useAPI";
const useCardsCarousel = ({ filters, queryParams, apiUrl }) => {
    const [wasFiltered, setWasFiltered] = useState(false);
    const [cards, setCards] = useState([]);
    const { get, setLoading, loading } = useApi();
    const { culture } = useDetectCurrentCulture();
    const filtersValue = useRef({ ...prepopulateFilterFromDefaultValues(filters), ...queryParams });
    const hasFilterOptions = !!filters && !!filters.length;
    const hasFilters = !!Object.values(filtersValue.current).filter(Boolean).length && hasFilterOptions;
    const getCarouselCardsData = useCallback(async () => {
        try {
            setLoading(true);
            const data = await get(`api/${culture}/${apiUrl}`, {
                params: { ...filtersValue.current, ...queryParams }
            }).json();
            setCards(data);
        }
        catch (error) {
            setCards([]);
        }
        finally {
            setLoading(false);
        }
    }, [culture]);
    const handleSelectorChanges = async (appliedFilters, ref) => {
        ref.current = generateFilterQueryParams(appliedFilters);
        setWasFiltered(true);
        await getCarouselCardsData();
    };
    const noResults = !loading && cards.length === 0;
    useEffect(() => {
        if (!!culture) {
            setLoading(false);
        }
    }, [culture]);
    return {
        cards,
        noResults,
        loading,
        filtersValue,
        hasFilters,
        wasFiltered,
        handleSelectorChanges
    };
};
export default useCardsCarousel;
